const validationSchema = {
  program: {},
  season: {},
  paymentAccount: {},
  name: {
    required: {
      value: true,
      error: 'A registration name is required.',
    },
  },
  fees: {
    range: {
      min: {
        value: 0,
        error: 'Cannot be negative number.',
      },
    },
  },
  participants: {},
  guardians: {},
  questions: {},
  waivers: {},
  participantGroups: {
    required: {
      value: true,
      error: 'A group must be defined.',
    },
  },
};

export default validationSchema;
